export function initColPadding() {
  const bodyElement = document.querySelector('body'),
    referenceColElement = document.querySelector('.col-1');

  function calculatePadding(element) {
    const paddingLeftString = window.getComputedStyle(element).getPropertyValue('padding-left');
    return Number(paddingLeftString.replace('px', ''));
  }

  function getCalculatedPaddingWidth(element) {
    return `${element.getBoundingClientRect().width + calculatePadding(element)}px`
  }

  bodyElement.style.setProperty('--col-1-width', getCalculatedPaddingWidth(referenceColElement));
  window.addEventListener('resize', () => {
    bodyElement.style.setProperty('--col-1-width', getCalculatedPaddingWidth(referenceColElement));
  });
}
